import z from 'zod'

export const StoreLookupRequestSchema = z.number().int()

export const StoreLookupProductSchema = z
  .object({
    trackId: z.number().int(),
    bundleId: z.string(),
    minimumOsVersion: z.string(),
    formattedPrice: z.string(),
    releaseDate: z.coerce.date(),
    trackName: z.string(),
    version: z.string(),
    artworkUrl512: z.string().url(),
    userRatingCount: z.number().int(),
    averageUserRating: z.number().min(0)
  })
  .transform((v) => ({
    ...v,
    src: v.artworkUrl512,
    url: new URL(`/app/id${v.trackId}`, 'https://apps.apple.com').href
  }))
export type StoreLookupProduct = z.infer<typeof StoreLookupProductSchema>

export const StoreLookupResponseSchema = z.object({
  results: z.array(StoreLookupProductSchema)
})
export type StoreLookupResponse = z.infer<typeof StoreLookupResponseSchema>
